import { useEffect, useRef, useState } from 'react';
import { RESOURCE_RECEIVE_DURATION_MS } from '../utils/resourceCelebrationTiming';

const useResourceReceiveAnimation = (impactVersion) => {
  // A newly mounted navbar has already missed any earlier reward arrivals.
  const previousImpactVersionRef = useRef(impactVersion);
  const [isReceivingReward, setIsReceivingReward] = useState(false);

  useEffect(() => {
    const previousImpactVersion = previousImpactVersionRef.current;
    previousImpactVersionRef.current = impactVersion;
    if (impactVersion <= previousImpactVersion) return undefined;

    setIsReceivingReward(true);
    const timerId = setTimeout(() => setIsReceivingReward(false), RESOURCE_RECEIVE_DURATION_MS);
    return () => clearTimeout(timerId);
  }, [impactVersion]);

  return isReceivingReward;
};

export default useResourceReceiveAnimation;
